export default __webpack_public_path__ + "static/media/kitchen5-beforeE-480w.b0ce194b.avif";